/* src/app/gui/components/spinner/spinner.component.css */
:host {
  position: fixed;
  inset: calc(var(--spacing, 0.25rem) * 0);
  z-index: 3000;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: color-mix(in srgb, #000 10%, transparent);
}
@supports (color: color-mix(in lab, red, red)) {
  :host {
    background-color: color-mix(in oklab, var(--color-black, #000) 10%, transparent);
  }
}
/*! tailwindcss v4.3.0 | MIT License | https://tailwindcss.com */
/*# sourceMappingURL=spinner.component.css.map */
